import { useDomainContext } from "@hooks/useDomainContext";
import React, { ReactElement } from "react";
import styles from "./legal.module.scss";
import TermsAndConditionsFallback from "./fallbacks/termsAndConditionsFallback";
import { formatTimestamp } from "@lib/sharedUtils";
export default function TermsAndConditions({
    domainNameAsProp,
    categoryNameAsProp = "Auto Warranty and Car insurance",
    className,
    mainWrapperClassName,
}: {
    domainNameAsProp?: string;
    categoryNameAsProp?: string;
    className?: string;
    mainWrapperClassName?: string;
}): ReactElement {
    const {
        domain: { name: actualDomainName, niceName, textBlocks, translations },
        category,
        domainNameTranslation,
    } = useDomainContext();
    const domainName = niceName ?? actualDomainName ?? domainNameAsProp;
    const categoryName = category?.name ?? categoryNameAsProp;
    const replaceDomainName = (text: string) => {
        return text
            .replace(/{domainName}/g, domainName)
            ?.replace(/{categoryName}/g, categoryName)
            ?.replace(/{mailInfo}/g, domainName.toLowerCase());
    };
    const terms =
        textBlocks?.find(
            (textBlock) =>
                textBlock.position === "custom-domain-terms-and-conditions",
        ) ||
        textBlocks?.find(
            (textBlock) =>
                textBlock.position === "custom-category-terms-and-conditions",
        );

    return terms ? (
        <div
            className={`${mainWrapperClassName ?? styles["legal"]} ${
                className ?? ""
            }`}
            dangerouslySetInnerHTML={{
                __html: `
                ${
                    terms.updatedAt
                        ? `<div class="timeStyle">${
                              translations?.[
                                  `${domainNameTranslation}_LastUpdated`
                              ] ?? "Last Updated:"
                          } ${formatTimestamp(terms.updatedAt)}</div>`
                        : ""
                }
                ${replaceDomainName(terms.text)}`,
            }}
        />
    ) : (
        <TermsAndConditionsFallback
            domainName={domainName}
            categoryName={categoryName}
            className={className}
            mainWrapperClassName={mainWrapperClassName}
        />
    );
}
